<div class="cell auto" *ngIf="displayMarks; else noStudy">
    <h2 class="_sansSerif _primary">{{''| translate}}</h2>

    <div *ngFor="let yearTeamsMarks of yearsTeamsMarks; index as i">
        <h3 class="marksYear">{{('common.year' | translate) + ' ' + (i + 1)}}</h3>
        <hr class="marksSeparation">
        <table class="_tableColor">
            <thead>
            <tr class="_titlePartTable">
                <th [i18nKey]="'common.team'"></th>
                <th style="text-align:center" *ngFor="let month of yearTeamsMarks.periodsMonths">{{('common.' + periodicity + '.' + month) |
                    translate}}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let teamNumber of yearTeamsMarks.teamsMarks | keys">
                <td *ngIf="teams">{{teams[teamNumber - 1].name}}</td>
                <td style="text-align:center" *ngFor="let mark of yearTeamsMarks.teamsMarks[teamNumber]">
                    {{mark | number:'1.2'}}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
<ng-template #noStudy>
    <div class="marksUnavailable cell auto grid-y align-center align-middle">
        <div class="cell shrink marksUnavailable-img"></div>
        <span class="cell shrink marksUnavailable-text"[i18nKey]="'evaluations.marks.unavailable'"></span>
        <kiwi-spacer [size]="16"></kiwi-spacer>
        <button class="button _primary _iconLeft"
                [routerLink]="'/session/decisions/period-completion/animator-decisions-closure'">
            <i class="fas fa-cogs"></i> <span [i18nKey]="'decisions.dashboard.period.completion'"></span></button>
    </div>
</ng-template>
